import { OpportunityWorkflowQuery } from "../../../lib/generated/app-service-gql/graphql";
import {
  OpportunityEntityType,
  OpportunityWorkflowTransitionGroup,
} from "../../../lib/types/graphQLEnums";
import { CreateOpportunityFormValues } from "./CreateOpportunityForm";

/**
 * Finds the appropriate default stage ID based on the form values and workflow
 *
 * For open tenders, it tries to use the first stage in the "Tender Qualification" group.
 * Otherwise, it defaults to the first stage in the workflow.
 */
export function getDefaultStageId(
  workflow: OpportunityWorkflowQuery["opportunityWorkflow"],
  defaultValues?: Partial<CreateOpportunityFormValues>,
): string | null {
  const hasNoticeEntity = defaultValues?.entities?.some(
    (entity) => entity.entityType === OpportunityEntityType.Notice,
  );

  // Check if it's an OPEN stage and a Tender stage
  const isOpenTenderStage =
    defaultValues?.stage === "OPEN" && defaultValues?.noticeStage === "Tender";

  if (isOpenTenderStage) {
    // Find the first transition in the Tender Qualification group
    const tenderQualificationStage = workflow.transitions.find(
      (transition) => transition.group === OpportunityWorkflowTransitionGroup.TenderQualification,
    );

    if (tenderQualificationStage) {
      return tenderQualificationStage.stage.id;
    }
  }

  // If there is a notice entity, default to the first stage
  if (hasNoticeEntity) {
    return workflow.transitions[0].stage.id;
  }

  // Otherwise let the user select the stage
  return null;
}
